// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorDotWithLabel-module__container--2PRjE","colorDot":"ColorDotWithLabel-module__colorDot--2P5mT"};